<script setup>
import {services} from '../../stores/storeMap';

const {store} = defineProps({
    store: {
        type: Object,
        required: true,
    },
});

const styles = {
    address: {
        fontSize: '14px',
        fontStyle: 'normal',
        marginBottom: store.services.length ? '8px' : '',
    },
    p: {
        margin: '0 0 8px 0',
    },
    ul: {
        margin: '0',
        paddingLeft: '16px',
    },
    li: index => ({
        marginBottom: index < (store.services.length - 1) ? '4px' : '',
    }),
};
</script>

<template>
    <p v-if="store.phoneNumber" :style="styles.p">
        <a :href="`tel:${store.phoneNumber}`">{{ store.phoneNumber }}</a>
    </p>
    <address :style="styles.address">
        {{ store.address }}<br>{{ store.postalCode }}&nbsp;{{ store.city }}
    </address>
    <template v-if="store.services.length">
        <p :style="styles.p"><strong>Services :</strong></p>
        <ul :style="styles.ul">
            <li v-for="(service, i) in store.services" :style="styles.li(i)">
                {{ services[service] }}
            </li>
        </ul>
    </template>
</template>
